import React from 'react';

import FormManager from 'src/core/gd-form/common/form-manager';
import SelectUser from 'core/gd-ui/select-user/select-user';
import Form from "../../../gd-form/form/form-ui5/form";
import FormRow from "../../../gd-form/form/form-ui5/form-row";
import SelectorInline from "../../../gd-components/selector/inline/selector-inline";
import FormActions from "../../../gd-form/form/form-ui5/actions";
import {ViewAccess} from "../../../gd/const/views/view-type-config";

export default class CustomViewAccessForm extends React.Component {

    constructor(props) {
        super(props);

        const initFormData = {
            access:                 this.props.view.access,
            sharedUsers:            this.props.view.sharedUsers,
        };

        const formStructure = {
            fields: {
                access:                 { type: 'select',   isRequired: false,  label: 'Access'},
                sharedUsers:            { type: 'select',   isRequired: false,  label: 'Shared users'},
            },
            onSubmit: this.onSubmit,
            isFormChanged: true,
        };

        this.form = new FormManager(formStructure, initFormData);
    }

    onAccessChanged = (value) => {
        this.form.onFormComponentValueChange('access', value);
        if (value === ViewAccess.PRIVATE) this.form.setValue('sharedUsers', []);

        this.forceUpdate();
    };

    getCompanyUsers = () => {
        // all company users
        let users = gd.session.companyUsers.filterByCompany(gd.companyId).map(companyUser => companyUser.user);

        // order by name
        users = _.sortBy(users, u => u.name);

        // to array of ids
        users = users.map(u => u.id);

        // remove self
        users = _.filter(users,  id=>id !== gd.session.me.id);
        return users;
    };

    onSubmit = (result) => {

        const {view} = this.props;
        const request = gd.api.Views.update(view.id, view.name, view.params, result.access, result.sharedUsers, view.sharedViewId, view.settings);

        request.done(response=>{
            // refresh header ?
            // there 2 types of views, one with data class one within
            // here we support both
            const app = gd.getApp();
            if (app.data && app.data.viewModel) {
                app.data.viewModel.access = result.access;
                app.data.viewModel.sharedUsers = result.sharedUsers;
            } else {
                app.viewModel.access = result.access;
                app.viewModel.sharedUsers = result.sharedUsers;
            }
            app.start();
            gd.bus.triggerEvent('view-top-panel:update');
            //

            gd.modal.hide();
        });
    };

    render() {

        const accessOptions = [
            {id: ViewAccess.PRIVATE,  label: "Private",  icon: 'i5-lock'},
            {id: ViewAccess.SHARED,   label: "Shared",   icon: 'i5-users'}
        ];

        return (

            <div className="ui5-plate modal-form">
            <Form form={this.form} size="size-30-70">

                <div className="f-tbl">

                    <FormRow label="Access">
                        <SelectorInline items={accessOptions}
                                        selectedId={this.form.getValue('access')}
                                        onChange={this.onAccessChanged} />
                    </FormRow>

                    {this.form.getValue('access') === ViewAccess.SHARED &&
                    <FormRow label="Users">
                        <SelectUser form={this.form}
                                    name="sharedUsers"
                                    multiselect={true}
                                    options={this.getCompanyUsers()}
                                    renderValue="form"
                                    placeholder="Select users"/>
                    </FormRow>
                    }


                </div>

                <FormActions form={this.form} />

            </Form>
            </div>
        );
    }
}